module.exports = __webpack_public_path__ + "static/media/textilesiliconefluid.ceaa5440.png";